import script from "./FleetManagedBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./FleetManagedBadge.vue?vue&type=script&setup=true&lang=ts"

import "./FleetManagedBadge.vue?vue&type=style&index=0&id=f1331e52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1331e52"]])

export default __exports__